export const environment = {
  production: false,
  host: 'https://localhost:4200',
  myurl: 'https://netclub-win-service-dev-hbdjb3aaeedgfsgz.eastus-01.azurewebsites.net'
  // Add other development-specific variables here if needed
}